export const REPLACE_NAME_VARIABLES = {
  name: '{{名前}}',
  onayami: '{{今悩んでいること}}',
}
